import { useEffect } from "react";
import { useListingQuery } from "../../api/hooks";

export function useWidgetTheme() {
  const { data: listing } = useListingQuery();

  useEffect(() => {
    const theme = listing?.widgetTheme;
    if (!theme) return;

    if (theme.primaryColor) {
      document.documentElement.style.setProperty("--widget-primary", theme.primaryColor);
      document.documentElement.style.setProperty("--widget-primary-dark", theme.primaryColor);
      document.documentElement.style.setProperty("--widget-primary-light", theme.primaryColor);
    }
    if (theme.primaryLightColor)
      document.documentElement.style.setProperty("--widget-primary-bg", theme.primaryLightColor);
    if (theme.buttonRadius)
      document.documentElement.style.setProperty("--widget-button-radius", theme.buttonRadius);
    if (theme.calendarTextColor)
      document.documentElement.style.setProperty("--widget-calendar-text", theme.calendarTextColor);
    if (theme.primaryTextColor)
      document.documentElement.style.setProperty("--widget-primary-text", theme.primaryTextColor);
  }, [listing?.widgetTheme]);
}
